// extracted by mini-css-extract-plugin
export var content = "_r8-1";
export var noScroll = "_r8-3";
export var paper = "_r8-0";
export var scrollable = "_r8-2";